export default __webpack_public_path__ + "static/media/gabriel.b6444bfc.png";